<template>
  <div>
    <div class="detial-top">
      <a-descriptions
        :title="
          personDetail.fullName ? '姓名：' + personDetail.fullName : '姓名：'
        "
      >
        <a-descriptions-item label="所在部门">
          {{ personDetail.organizationName }}
        </a-descriptions-item>
        <a-descriptions-item label="人事编号">
          {{ personDetail.number }}
        </a-descriptions-item>
        <a-descriptions-item label="身份证号码">
          {{ personDetail.idCardNumber }}
        </a-descriptions-item>
        <a-descriptions-item label="联系电话">
          {{ personDetail.phone }}</a-descriptions-item
        >
        <a-descriptions-item label="人员编号">
          {{ personDetail.personalNumber }}</a-descriptions-item
        >
      </a-descriptions>
      <div class="detial-top-btn">
        <a-dropdown>
          <a-menu slot="overlay" @click="handleMenuClick">
            <a-menu-item key="1_pdf"> 个人信息表 </a-menu-item>
            <a-menu-item key="2_pdf"> 个人履历表</a-menu-item>
          </a-menu>
          <a-button type="primary" icon="file-pdf">
            导出PDF <a-icon type="down" />
          </a-button>
        </a-dropdown>
        <a-dropdown>
          <a-menu slot="overlay" @click="handleMenuClick">
            <a-menu-item key="1_printer"> 个人信息表 </a-menu-item>
            <a-menu-item key="2_printer"> 个人履历表</a-menu-item>
          </a-menu>
          <a-button type="primary" icon="printer">
            打印 <a-icon type="down" />
          </a-button>
        </a-dropdown>
      </div>
    </div>
    <div class="detial-cont">
      <div class="detial-cont-title">工作信息</div>
      <blank height="1"> </blank>
      <div class="detial-cont-view">
        <a-descriptions>
          <a-descriptions-item label="行政职务">
            <template v-if="organizationId == 100101">
              {{ personDetail.mfPosition }}
            </template>
            <template v-else>
              {{ getByTypeName(personDetail.position, positionList) }}
            </template>
          </a-descriptions-item>
          <a-descriptions-item label="任现职务时间">
            {{ personDetail.positionTime }}
          </a-descriptions-item>
          <a-descriptions-item label="任现职务年限">
            {{ personDetail.positionAge }}
          </a-descriptions-item>
          <a-descriptions-item label="职级" v-if="organizationId != 100101">
            {{ getByTypeName(personDetail.positionLevel, positionLevelList) }}
          </a-descriptions-item>
          <a-descriptions-item
            label="在职人员档案号"
            v-if="organizationId == 100101"
          >
            {{ personDetail.archiveseNumber }}
          </a-descriptions-item>
          <a-descriptions-item label="任现职级时间">
            {{ personDetail.positionLevelTime }}
          </a-descriptions-item>
          <a-descriptions-item label="任现职级年限">
            {{ personDetail.positionLevelAge }}
          </a-descriptions-item>
          <a-descriptions-item label="技术职称">
            {{ personDetail.technicalTitle }}
          </a-descriptions-item>
          <a-descriptions-item label="职称聘任时间">
            {{ personDetail.appointmentTime }}
          </a-descriptions-item>
          <a-descriptions-item label="职称获得时间">
            {{ personDetail.acquisitionTime }}
          </a-descriptions-item>
          <a-descriptions-item label="首次参加工作时间">
            {{ personDetail.firstWorkTime }}
          </a-descriptions-item>
          <a-descriptions-item label="进入民政系统时间">
            {{ personDetail.civilOfficeSysTime }}</a-descriptions-item
          >
          <a-descriptions-item>
            <span slot="label"
              >{{
                organizationId == 100101
                  ? '进入本公司系统时间'
                  : '进入总公司系统时间'
              }}
            </span>
            {{ personDetail.headOfficeSysTime }}
          </a-descriptions-item>
          <a-descriptions-item label="总工龄">
            {{ personDetail.totalSystemAge }}
          </a-descriptions-item>
          <a-descriptions-item label="本单位工龄">
            {{ personDetail.currentOfficeSysAge }}
          </a-descriptions-item>
          <a-descriptions-item>
            <span slot="label"
              >{{
                organizationId == 100101
                  ? '进入本公司机关时间'
                  : '进入本单位时间'
              }}
            </span>
            {{ personDetail.currentOfficeSysTime }}
          </a-descriptions-item>
        </a-descriptions>
        <blank height="40"> </blank>
        <a-descriptions>
          <a-descriptions-item> 合同信息 </a-descriptions-item>
          <br />
          <br />

          <a-descriptions-item label="首次签订合同时间">
            {{ personDetail.firstSignContractTime }}
          </a-descriptions-item>
          <a-descriptions-item label="首次签订合同类型">
            {{
              getByTypeName(personDetail.firstContractType, contractTypeList)
            }}
          </a-descriptions-item>
          <a-descriptions-item label="首次签订合同年限">
            {{ personDetail.firstContractYears }}</a-descriptions-item
          >
          <a-descriptions-item label="首次签订到期时间">
            {{ personDetail.firstContractExpirationTime }}
          </a-descriptions-item>
          <a-descriptions-item label="续订1合同时间">
            {{ personDetail.secondSignContractTime }}</a-descriptions-item
          >
          <a-descriptions-item label="续订1合同类型">
            {{
              getByTypeName(personDetail.secondContractType, contractTypeList)
            }}
          </a-descriptions-item>
          <a-descriptions-item label="续订1合同年限">
            {{ personDetail.secondContractYears }}</a-descriptions-item
          >
          <a-descriptions-item label="续订1到期时间">
            {{ personDetail.secondContractExpirationTime }}
          </a-descriptions-item>
          <a-descriptions-item label="续订2合同时间">
            {{ personDetail.thirdSignContractTime }}</a-descriptions-item
          >
          <a-descriptions-item label="续订2合同类型">
            {{
              getByTypeName(personDetail.thirdContractType, contractTypeList)
            }}
          </a-descriptions-item>
          <a-descriptions-item label="续订2合同年限">
            {{ personDetail.thirdContractYears }}</a-descriptions-item
          >
          <a-descriptions-item label="续订2到期时间">
            {{ personDetail.thirdContractExpirationTime }}
          </a-descriptions-item>
        </a-descriptions>
        <blank height="40"> </blank>
        <div class="personage">
          <div class="personage-title">个人情况</div>
          <div class="personage-cont">
            <a-descriptions style="border-bottom: #e9e9e9 1px solid">
              <a-descriptions-item> 个人基本信息 </a-descriptions-item>
              <br />
              <br />
              <a-descriptions-item label="姓名"
                >{{ personDetail.fullName }}
              </a-descriptions-item>
              <a-descriptions-item label="性别">
                {{ personDetail.sex }}</a-descriptions-item
              >
              <a-descriptions-item label="出生年月">
                {{ personDetail.birthTime }}</a-descriptions-item
              >
              <a-descriptions-item label="年龄">
                {{ personDetail.age }}
              </a-descriptions-item>
              <a-descriptions-item label="民族">
                {{ personDetail.nation }}
              </a-descriptions-item>

              <a-descriptions-item label="籍贯">
                {{ personDetail.nativePlace }}
              </a-descriptions-item>
              <a-descriptions-item label="出生地">
                {{ personDetail.birthplace }}
              </a-descriptions-item>
              <a-descriptions-item label="政治面貌">
                {{
                  getByTypeName(personDetail.politicalType, politicalTypeList)
                }}
              </a-descriptions-item>
              <a-descriptions-item
                label="入党时间"
                v-if="personDetail.joinPartyTime"
              >
                {{ personDetail.joinPartyTime }}
              </a-descriptions-item>
              <a-descriptions-item label="户口所在地">
                {{ personDetail.registeredResidence }}
              </a-descriptions-item>
              <a-descriptions-item label="户口性质">
                {{
                  getByTypeName(
                    personDetail.registeredNature,
                    registeredNatureList
                  )
                }}
              </a-descriptions-item>
              <a-descriptions-item label="健康状况">
                {{ getByTypeName(personDetail.healthStatus, healthStatusList) }}
              </a-descriptions-item>
              <a-descriptions-item label="家庭地址">
                {{ personDetail.homeAddress }}
              </a-descriptions-item>
              <a-descriptions-item
                label="紧急联系人"
                v-if="organizationId == 100101"
              >
                {{ personDetail.emergencyContact || '' }}</a-descriptions-item
              >
              <a-descriptions-item
                label="紧急联系人关系"
                v-if="organizationId == 100101"
              >
                {{
                  personDetail.emergencyContactRelationship || ''
                }}</a-descriptions-item
              >
              <a-descriptions-item
                label="紧急联系人电话"
                v-if="organizationId == 100101"
              >
                {{
                  personDetail.emergencyContactPhone || ''
                }}</a-descriptions-item
              >
            </a-descriptions>
            <blank height="16"> </blank>
            <a-descriptions>
              <a-descriptions-item> 学历信息 </a-descriptions-item>
              <br />
              <br />
              <a-descriptions-item label="全日制教育学历">
                {{
                  getByTypeName(personDetail.firstEducation, educationList)
                }}</a-descriptions-item
              >
              <a-descriptions-item label="全日制教育学位">
                {{ personDetail.firstAcademicDegree }}</a-descriptions-item
              >
              <a-descriptions-item label="全日制教育专业">
                {{ personDetail.firstMajor }}</a-descriptions-item
              >

              <a-descriptions-item label="全日制教育毕业院校">
                {{ personDetail.firstGraduationSchool }}</a-descriptions-item
              >
              <a-descriptions-item label="在职教育学历">
                {{ getByTypeName(personDetail.education, educationList) }}
              </a-descriptions-item>
              <a-descriptions-item label="在职教育学位">
                {{ personDetail.academicDegree }}</a-descriptions-item
              >
              <a-descriptions-item label="在职教育专业">
                {{ personDetail.major }}</a-descriptions-item
              >
              <a-descriptions-item label="在职教育毕业院校">
                {{ personDetail.graduationSchool }}</a-descriptions-item
              >
            </a-descriptions>
            <template>
              <blank height="16"> </blank>
              <a-descriptions>
                <a-descriptions-item> 状态信息 </a-descriptions-item>
                <br />
                <br />
                <a-descriptions-item label="状态">
                  {{
                    getByTypeName(
                      personDetail.positionStatus,
                      positionStatusList
                    )
                  }}
                </a-descriptions-item>
                <a-descriptions-item
                  label="减员日期"
                  v-if="personDetail.attrtionTiem"
                >
                  {{ personDetail.attrtionTiem }}
                </a-descriptions-item>
                <a-descriptions-item
                  label="减员备注"
                  v-if="personDetail.attrtionDes"
                >
                  {{ personDetail.attrtionDes }}
                </a-descriptions-item>
              </a-descriptions>
            </template>
          </div>
        </div>
        <!-- <blank height="170"> </blank> -->
      </div>
    </div>
    <!-- 开具材料情况 -->
    <div class="detial-cont" v-if="organizationId == 100101">
      <div class="detial-cont-title">开具材料情况</div>
      <blank height="1"> </blank>
      <div class="detial-cont-view">
        <materialsTable
          v-model="personDetail.personnelManagerScienceList"
          :file="personDetail.personnelManagerScienceList"
          :id="id"
          :disabled="true"
        ></materialsTable>
      </div>
    </div>
    <appfloor v-if="version || year || month"></appfloor>
    <bottomSuspension v-else>
      <a-button :style="{ marginRight: '26px' }" @click="goBack">
        返回
      </a-button>
      <!-- <a-button
        type="primary"
        :style="{ marginRight: '42px' }"
        @click="setpop()"
      >
        减员
      </a-button> -->
    </bottomSuspension>

    <a-modal
      v-model="ispop"
      title="减员操作"
      @ok="handleOk"
      :confirm-loading="confirmLoading"
    >
      <prompts> 请选择减员原因，并填写减员备注信息</prompts>
      <div class="dep-form">
        <div class="dep-form-item">
          <div class="dep-form-lable">减员原因：</div>
          <a-radio-group v-model="delData.positionStatus">
            <template v-for="item in positionStatusList">
              <a-radio
                :value="item.valuename"
                :key="item.id"
                v-if="item.valuename !== '1001'"
              >
                {{ item.keyname }}
              </a-radio>
            </template>
          </a-radio-group>
        </div>
        <blank height="25"> </blank>
        <div class="dep-form-item">
          <div class="dep-form-lable">减员备注：</div>
        </div>
        <div class="dep-form-item">
          <a-input
            v-model="delData.cause"
            type="textarea"
            class="w500"
            :auto-size="{ minRows: 4, maxRows: 6 }"
          />
        </div>
      </div>
    </a-modal>
    <!-- 打印 -->
    <print v-model="isPrint">
      <!-- 基 本 信 息 -->
      <div v-if="printKey === '1'">
        <blank height="30"> </blank>
        <div class="print-title">北京市民政工业总公司职工个人信息表</div>
        <div class="print-border">
          <div class="Pprintd-cont-title">基本信息</div>
          <a-descriptions bordered size="small" :column="4">
            <a-descriptions-item>
              <div slot="label" class="printCenter fwLabel">姓名</div>
              <div class="printCenter">
                {{ personDetail.fullName }}
              </div>
            </a-descriptions-item>
            <a-descriptions-item>
              <div slot="label" class="printCenter fwLabel">性别</div>
              <div class="printCenter">
                {{ personDetail.sex }}
              </div>
            </a-descriptions-item>
            <a-descriptions-item>
              <div slot="label" class="printCenter fwLabel">身份证号码</div>
              <div class="printCenter">
                {{ personDetail.idCardNumber }}
              </div>
            </a-descriptions-item>
            <a-descriptions-item>
              <div slot="label" class="printCenter fwLabel">出生年月</div>
              <div class="printCenter">
                {{
                  personDetail.birthTime_s
                    ? personDetail.birthTime_s.substring(0, 8)
                    : ''
                }}
              </div>
            </a-descriptions-item>
            <a-descriptions-item>
              <div slot="label" class="printCenter fwLabel">年龄</div>
              <div class="printCenter">{{ personDetail.age }}岁</div>
            </a-descriptions-item>
            <a-descriptions-item>
              <div slot="label" class="printCenter fwLabel">民族</div>
              <div class="printCenter">
                {{ personDetail.nation }}
              </div>
            </a-descriptions-item>
            <a-descriptions-item>
              <div slot="label" class="printCenter fwLabel">籍贯</div>
              <div class="printCenter">
                {{ personDetail.nativePlace }}
              </div>
            </a-descriptions-item>
            <a-descriptions-item>
              <div slot="label" class="printCenter fwLabel">出生地</div>
              <div class="printCenter">
                {{ personDetail.birthplace }}
              </div>
            </a-descriptions-item>
            <a-descriptions-item>
              <div slot="label" class="printCenter fwLabel">政治面貌</div>
              <div class="printCenter">
                {{
                  getByTypeName(personDetail.politicalType, politicalTypeList)
                }}
              </div>
            </a-descriptions-item>
            <a-descriptions-item>
              <div slot="label" class="printCenter fwLabel">入党时间</div>
              <div class="printCenter">
                {{
                  personDetail.joinPartyTime_s
                    ? personDetail.joinPartyTime_s.substring(0, 8)
                    : ''
                }}
              </div>
            </a-descriptions-item>
            <a-descriptions-item>
              <div slot="label" class="printCenter fwLabel">户口所在地</div>
              <div class="printCenter">
                {{ personDetail.registeredResidence }}
              </div>
            </a-descriptions-item>
            <a-descriptions-item>
              <div slot="label" class="printCenter fwLabel">户口性质</div>
              <div class="printCenter">
                {{
                  getByTypeName(
                    personDetail.registeredNature,
                    registeredNatureList
                  )
                }}
              </div>
            </a-descriptions-item>
            <a-descriptions-item>
              <div slot="label" class="printCenter fwLabel">健康状况</div>
              <div class="printCenter">
                {{ getByTypeName(personDetail.healthStatus, healthStatusList) }}
              </div>
            </a-descriptions-item>
            <a-descriptions-item>
              <div slot="label" class="printCenter fwLabel">联系电话</div>
              <div class="printCenter">
                {{ personDetail.phone }}
              </div>
            </a-descriptions-item>
            <a-descriptions-item>
              <div slot="label" class="printCenter fwLabel">家庭地址</div>
              <div class="printCenter">
                {{ personDetail.homeAddress }}
              </div>
            </a-descriptions-item>
          </a-descriptions>
          <div class="Pprintd-cont-title">学历信息</div>
          <a-descriptions bordered size="small" :column="2">
            <a-descriptions-item>
              <div slot="label">
                <div class="printCenter fwLabel">全日制教育</div>
                <div class="printCenter fwLabel">学历学位</div>
              </div>
              <div class="printCenter">
                {{ getByTypeName(personDetail.firstEducation, educationList) }}
              </div>
              <div class="printCenter">
                {{ personDetail.firstAcademicDegree }}
              </div>
            </a-descriptions-item>
            <a-descriptions-item>
              <div slot="label">
                <div class="printCenter fwLabel">全日制教育</div>
                <div class="printCenter fwLabel">毕业院校系及专业</div>
              </div>
              <div class="printCenter">
                {{ personDetail.firstGraduationSchool }}
              </div>
              <div class="printCenter">{{ personDetail.firstMajor }}</div>
            </a-descriptions-item>
            <a-descriptions-item>
              <div slot="label">
                <div class="printCenter fwLabel">在职教育</div>
                <div class="printCenter fwLabel">学历学位</div>
              </div>
              <div class="printCenter">
                {{ getByTypeName(personDetail.education, educationList) }}
              </div>
              <div class="printCenter">{{ personDetail.academicDegree }}</div>
            </a-descriptions-item>
            <a-descriptions-item>
              <div slot="label">
                <div class="printCenter fwLabel">在职教育</div>
                <div class="printCenter fwLabel">毕业院校系及专业</div>
              </div>
              <div class="printCenter">
                {{ personDetail.graduationSchool }}
              </div>
              <div class="printCenter">{{ personDetail.major }}</div>
            </a-descriptions-item>
          </a-descriptions>
          <div class="Pprintd-cont-title">工作信息</div>
          <a-descriptions bordered size="small" :column="3">
            <a-descriptions-item span="3">
              <div slot="label" class="printCenter fwLabel">所在部门</div>
              <div class="printCenter">
                {{ personDetail.organizationName }}
              </div>
            </a-descriptions-item>
            <a-descriptions-item>
              <div slot="label" class="printCenter fwLabel">行政职务</div>
              <div class="printCenter">
                {{ getByTypeName(personDetail.position, positionList) }}
              </div>
            </a-descriptions-item>
            <a-descriptions-item>
              <div slot="label" class="printCenter fwLabel">任现职务时间</div>
              <div class="printCenter">
                {{ personDetail.positionTime_s }}
              </div>
            </a-descriptions-item>
            <a-descriptions-item>
              <div slot="label" class="printCenter fwLabel">任现职务年限</div>
              <div class="printCenter">
                {{ personDetail.positionAge }}
              </div>
            </a-descriptions-item>
            <a-descriptions-item>
              <div slot="label" class="printCenter fwLabel">职级</div>
              <div class="printCenter">
                {{
                  getByTypeName(personDetail.positionLevel, positionLevelList)
                }}
              </div>
            </a-descriptions-item>
            <a-descriptions-item>
              <div slot="label" class="printCenter fwLabel">任现职级时间</div>
              <div class="printCenter">
                {{ personDetail.positionLevelTime_s }}
              </div>
            </a-descriptions-item>
            <a-descriptions-item>
              <div slot="label" class="printCenter fwLabel">任现职级年限</div>
              <div class="printCenter">
                {{ personDetail.positionLevelAge }}
              </div>
            </a-descriptions-item>
            <a-descriptions-item>
              <div slot="label" class="printCenter fwLabel">技术职称</div>
              <div class="printCenter">
                {{ personDetail.technicalTitle }}
              </div>
            </a-descriptions-item>
            <a-descriptions-item>
              <div slot="label" class="printCenter fwLabel">职称聘任时间</div>
              <div class="printCenter">
                {{
                  personDetail.appointmentTime_s
                    ? personDetail.appointmentTime_s.substring(0, 8)
                    : ''
                }}
              </div>
            </a-descriptions-item>
            <a-descriptions-item>
              <div slot="label" class="printCenter fwLabel">职称获得时间</div>
              <div class="printCenter">
                {{
                  personDetail.acquisitionTime_s
                    ? personDetail.acquisitionTime_s.substring(0, 8)
                    : ''
                }}
              </div>
            </a-descriptions-item>
            <a-descriptions-item span="1.5">
              <div slot="label" class="printCenter fwLabel">
                首次参加工作时间
              </div>
              <div class="printCenter">
                {{ personDetail.firstWorkTime_s }}
              </div>
            </a-descriptions-item>
            <a-descriptions-item span="1.5">
              <div slot="label" class="printCenter fwLabel">总工龄</div>
              <div class="printCenter">
                {{ personDetail.totalSystemAge }}
              </div>
            </a-descriptions-item>
            <a-descriptions-item span="1.5">
              <div slot="label" class="printCenter fwLabel">
                {{
                  organizationId == 100101
                    ? '进入本公司机关时间'
                    : '进入本单位时间'
                }}
              </div>
              <div class="printCenter">
                {{ personDetail.currentOfficeSysTime_s }}
              </div>
            </a-descriptions-item>
            <a-descriptions-item span="1.5">
              <div slot="label" class="printCenter fwLabel">本单位工龄</div>
              <div class="printCenter">
                {{ personDetail.currentOfficeSysAge }}
              </div>
            </a-descriptions-item>
            <a-descriptions-item span="1.5">
              <div slot="label" class="printCenter fwLabel">
                进入民政系统时间
              </div>
              <div class="printCenter">
                {{ personDetail.civilOfficeSysTime_s }}
              </div>
            </a-descriptions-item>
            <a-descriptions-item span="1.5">
              <div slot="label" class="printCenter fwLabel">
                {{
                  organizationId == 100101
                    ? '进入本公司系统时间'
                    : '进入总公司系统时间'
                }}
              </div>
              <div class="printCenter">
                {{ personDetail.headOfficeSysTime_s }}
              </div>
            </a-descriptions-item>
          </a-descriptions>
          <div class="Pprintd-cont-title">合同信息</div>
          <a-descriptions bordered size="small" :column="4">
            <a-descriptions-item>
              <div slot="label">
                <div class="printCenter fwLabel">首次签订</div>
                <div class="printCenter fwLabel">合同时间</div>
              </div>
              <div class="printCenter">
                {{
                  personDetail.firstSignContractTime_s
                    ? personDetail.firstSignContractTime_s.substring(0, 8)
                    : personDetail.firstSignContractTime_s
                }}
              </div>
            </a-descriptions-item>
            <a-descriptions-item>
              <div slot="label">
                <div class="printCenter fwLabel">首次签订</div>
                <div class="printCenter fwLabel">合同类型</div>
              </div>
              <div class="printCenter">
                {{
                  getByTypeName(
                    personDetail.firstContractType,
                    contractTypeList
                  )
                }}
              </div>
            </a-descriptions-item>
            <a-descriptions-item>
              <div slot="label">
                <div class="printCenter fwLabel">首次签订</div>
                <div class="printCenter fwLabel">合同年限</div>
              </div>
              <div class="printCenter">
                {{
                  personDetail.firstContractYears
                    ? personDetail.firstContractYears + '年'
                    : personDetail.firstContractYears
                }}
              </div>
            </a-descriptions-item>
            <a-descriptions-item>
              <div slot="label">
                <div class="printCenter fwLabel">首次签订</div>
                <div class="printCenter fwLabel">到期时间</div>
              </div>
              <div class="printCenter">
                {{
                  personDetail.firstContractExpirationTime_s
                    ? personDetail.firstContractExpirationTime_s.substring(0, 8)
                    : personDetail.firstContractExpirationTime_s
                }}
              </div>
            </a-descriptions-item>
            <a-descriptions-item>
              <div slot="label">
                <div class="printCenter fwLabel">续订1</div>
                <div class="printCenter fwLabel">合同时间</div>
              </div>
              <div class="printCenter">
                {{
                  personDetail.secondSignContractTime_s
                    ? personDetail.secondSignContractTime_s.substring(0, 8)
                    : personDetail.secondSignContractTime_s
                }}
              </div>
            </a-descriptions-item>
            <a-descriptions-item>
              <div slot="label">
                <div class="printCenter fwLabel">续订1</div>
                <div class="printCenter fwLabel">合同类型</div>
              </div>
              <div class="printCenter">
                {{
                  getByTypeName(
                    personDetail.secondContractType,
                    contractTypeList
                  )
                }}
              </div>
            </a-descriptions-item>
            <a-descriptions-item>
              <div slot="label">
                <div class="printCenter fwLabel">续订1</div>
                <div class="printCenter fwLabel">合同年限</div>
              </div>
              <div class="printCenter">
                {{
                  personDetail.secondContractYears
                    ? personDetail.secondContractYears + '年'
                    : personDetail.secondContractYears
                }}
              </div>
            </a-descriptions-item>
            <a-descriptions-item>
              <div slot="label">
                <div class="printCenter fwLabel">续订1</div>
                <div class="printCenter fwLabel">到期时间</div>
              </div>
              <div class="printCenter">
                {{
                  personDetail.secondContractExpirationTime_s
                    ? personDetail.secondContractExpirationTime_s.substring(
                        0,
                        8
                      )
                    : personDetail.secondContractExpirationTime_s
                }}
              </div>
            </a-descriptions-item>
            <a-descriptions-item>
              <div slot="label">
                <div class="printCenter fwLabel">续订2</div>
                <div class="printCenter fwLabel">合同时间</div>
              </div>
              <div class="printCenter">
                {{
                  personDetail.thirdSignContractTime_s
                    ? personDetail.thirdSignContractTime_s.substring(0, 8)
                    : personDetail.thirdSignContractTime_s
                }}
              </div>
            </a-descriptions-item>
            <a-descriptions-item>
              <div slot="label">
                <div class="printCenter fwLabel">续订2</div>
                <div class="printCenter fwLabel">合同类型</div>
              </div>
              <div class="printCenter">
                {{
                  getByTypeName(
                    personDetail.thirdContractType,
                    contractTypeList
                  )
                }}
              </div>
            </a-descriptions-item>
            <a-descriptions-item>
              <div slot="label">
                <div class="printCenter fwLabel">续订2</div>
                <div class="printCenter fwLabel">合同年限</div>
              </div>
              <div class="printCenter">
                {{ personDetail.thirdContractYears }}
              </div>
            </a-descriptions-item>
            <a-descriptions-item>
              <div slot="label">
                <div class="printCenter fwLabel">续订2</div>
                <div class="printCenter fwLabel">到期时间</div>
              </div>
              <div class="printCenter">
                {{ personDetail.thirdContractExpirationTime }}
              </div>
            </a-descriptions-item>
            <a-descriptions-item>
              <div slot="label">
                <div class="printCenter fwLabel">合同变更</div>
                <div class="printCenter fwLabel">及备注</div>
              </div>
            </a-descriptions-item>
          </a-descriptions>
        </div>
      </div>
      <!-- 个 人 履 历 -->
      <div v-if="printKey === '2'">
        <blank height="30"> </blank>
        <div class="print-border print-poths">
          <div class="print-title">个 人 履 历</div>
          <div class="haveImg">
            <div class="haveImg-left">
              <a-descriptions bordered size="small" :column="3">
                <a-descriptions-item>
                  <div slot="label" class="printCenter fwLabel">姓名</div>
                  <div class="printCenter">
                    {{ personDetail.fullName }}
                  </div>
                </a-descriptions-item>
                <a-descriptions-item>
                  <div slot="label" class="printCenter fwLabel">性别</div>
                  <div class="printCenter">
                    {{ personDetail.sex }}
                  </div>
                </a-descriptions-item>
                <a-descriptions-item>
                  <div slot="label">
                    <div class="printCenter fwLabel">出生年月</div>
                    <div class="printCenter fwLabel">(岁)</div>
                  </div>
                  <div class="printCenter">
                    {{ personDetail.birthTime_s }}
                  </div>
                  <div class="printCenter">({{ personDetail.age }}岁)</div>
                </a-descriptions-item>
                <a-descriptions-item>
                  <div slot="label" class="printCenter fwLabel">民族</div>
                  <div class="printCenter">
                    {{ personDetail.nation }}
                  </div>
                </a-descriptions-item>
                <a-descriptions-item>
                  <div slot="label" class="printCenter fwLabel">籍贯</div>
                  <div class="printCenter">
                    {{ personDetail.nativePlace }}
                  </div>
                </a-descriptions-item>
                <a-descriptions-item>
                  <div slot="label" class="printCenter fwLabel">出生地</div>
                  <div class="printCenter">
                    {{ personDetail.birthplace }}
                  </div>
                </a-descriptions-item>
                <a-descriptions-item>
                  <div slot="label" class="printCenter fwLabel">政治面貌</div>
                  <div class="printCenter">
                    {{
                      getByTypeName(
                        personDetail.politicalType,
                        politicalTypeList
                      )
                    }}
                  </div>
                </a-descriptions-item>
                <a-descriptions-item>
                  <div slot="label" class="printCenter fwLabel">入党时间</div>
                  <div class="printCenter">
                    {{
                      personDetail.joinPartyTime_s
                        ? personDetail.joinPartyTime_s.substring(0, 8)
                        : ''
                    }}
                  </div>
                </a-descriptions-item>
                <a-descriptions-item>
                  <div slot="label" class="printCenter fwLabel">健康状况</div>
                  <div class="printCenter">
                    {{
                      getByTypeName(personDetail.healthStatus, healthStatusList)
                    }}
                  </div>
                </a-descriptions-item>
              </a-descriptions>
            </div>
            <div
              class="isImg"
              :style="isPrint.printTitle == 'pdf' ? 'height:139px' : ''"
            >
              <span>照片</span>
            </div>
          </div>
          <a-descriptions
            style="margin-top: -2px; z-index: 200"
            bordered
            size="small"
            :column="2"
          >
            <a-descriptions-item>
              <div slot="label">
                <div class="printCenter fwLabel">技术职称</div>
              </div>
              <div class="printCenter">{{ personDetail.technicalTitle }}</div>
            </a-descriptions-item>
            <a-descriptions-item>
              <div slot="label">
                <div class="printCenter fwLabel">参加工作时间</div>
              </div>
              <div class="printCenter">{{ personDetail.firstWorkTime_s }}</div>
            </a-descriptions-item>
            <a-descriptions-item>
              <div slot="label">
                <div class="printCenter fwLabel">进入本单位时间</div>
              </div>
              <div class="printCenter">
                {{ personDetail.currentOfficeSysTime_s }}
              </div>
            </a-descriptions-item>
            <a-descriptions-item>
              <div slot="label">
                <div class="printCenter fwLabel">总工龄</div>
              </div>
              <div class="printCenter">
                {{ personDetail.totalSystemAge }}
              </div>
            </a-descriptions-item>
            <a-descriptions-item>
              <div slot="label">
                <div class="printCenter fwLabel">全日制教育</div>
                <div class="printCenter fwLabel">学历学位</div>
              </div>
              <div class="printCenter">
                {{ getByTypeName(personDetail.firstEducation, educationList) }}
              </div>
              <div class="printCenter">
                {{ personDetail.firstAcademicDegree }}
              </div>
            </a-descriptions-item>
            <a-descriptions-item>
              <div slot="label">
                <div class="printCenter fwLabel">全日制教育</div>
                <div class="printCenter fwLabel">毕业院校系及专业</div>
              </div>
              <div class="printCenter">
                {{ personDetail.firstGraduationSchool }}
              </div>
              <div class="printCenter">{{ personDetail.firstMajor }}</div>
            </a-descriptions-item>
            <a-descriptions-item>
              <div slot="label">
                <div class="printCenter fwLabel">在职教育</div>
                <div class="printCenter fwLabel">学历学位</div>
              </div>
              <div class="printCenter">
                {{ getByTypeName(personDetail.education, educationList) }}
              </div>
              <div class="printCenter">{{ personDetail.academicDegree }}</div>
            </a-descriptions-item>
            <a-descriptions-item>
              <div slot="label">
                <div class="printCenter fwLabel">在职教育</div>
                <div class="printCenter fwLabel">毕业院校系及专业</div>
              </div>
              <div class="printCenter">
                {{ personDetail.graduationSchool }}
              </div>
              <div class="printCenter">{{ personDetail.major }}</div>
            </a-descriptions-item>
            <a-descriptions-item span="2">
              <div slot="label" class="printCenter fwLabel">现任职务</div>
              <div class="printCenter">
                <span v-if="getIsLead() != -1">
                  北京市民政工业总公司{{
                    getByTypeName(personDetail.position, positionList)
                  }}
                </span>
                <span v-else>
                  北京市民政工业总公司{{ personDetail.organizationName
                  }}{{ getByTypeName(personDetail.position, positionList) }}
                </span>
              </div>
            </a-descriptions-item>
            <a-descriptions-item span="2">
              <div slot="label" class="printCenter fwLabel">任现职务时间</div>
              <div class="printCenter">
                {{ personDetail.positionTime_s }}
              </div>
            </a-descriptions-item>
            <a-descriptions-item span="2">
              <div slot="label" class="printCenter fwLabel">现任职级</div>
              <div class="printCenter">
                {{
                  getByTypeName(personDetail.positionLevel, positionLevelList)
                }}
              </div>
            </a-descriptions-item>
            <a-descriptions-item span="2">
              <div slot="label" class="printCenter fwLabel">任现职级时间</div>
              <div class="printCenter">
                {{ personDetail.positionLevelTime_s }}
              </div>
            </a-descriptions-item>
          </a-descriptions>
          <a-descriptions
            style="margin-top: -4px"
            bordered
            size="small"
            :column="1"
          >
            <a-descriptions-item>
              <div slot="label">
                <div class="printCenter fwLabel">履</div>
                <blank height="60"> </blank>
                <div class="printCenter fwLabel">历</div>
              </div>

              <blank height="200" style="width: 250px"> </blank>
            </a-descriptions-item>
          </a-descriptions>
        </div>
      </div>
    </print>
  </div>
</template>

<script>
import {
  personnelGet,
  updatePositionStatus,
  getHistoryDetial,
  getJobDetial
} from './api/api'
import { mapState, mapActions } from 'vuex'
import materialsTable from './TheDead/components/materials-table.vue'
import personnelDetailPrintPage from './components/personnelDetailPrintPage.vue'
export default {
  components: {
    materialsTable,
    personnelDetailPrintPage
  },
  data() {
    return {
      confirmLoading: false,
      ispop: false, // 减员弹窗
      isPrint: {
        printStatus: false,
        printTitle: ''
      }, // 打印弹窗
      printKey: '1', //1 个人信息 2 个人履历
      labelCol: { span: 4 },
      wrapperCol: { span: 14 },
      personDetail: {}, // 详情
      delData: {}, // 减员操作信息
      id: '',
      version: '', //历史版本
      year: '', // 年
      month: '' // 月
    }
  },
  computed: {
    // 公司id  区别民福民政 以及显示字段
    organizationId() {
      return this.$store.state.app.userInfo.tenantId
    },
    ...mapState({
      positionList: (state) => state.bytype.positionList, //行政职务
      positionLevelList: (state) => state.bytype.positionLevelList, //职级
      politicalTypeList: (state) => state.bytype.politicalTypeList, //政治面貌
      contractTypeList: (state) => state.bytype.contractTypeList, //劳动合同类型
      educationList: (state) => state.bytype.educationList, //学历
      registeredNatureList: (state) => state.bytype.registeredNatureList, //户口性质
      healthStatusList: (state) => state.bytype.healthStatusList, //健康状况
      positionStatusList: (state) => state.bytype.positionStatusList //减员原因
    })
  },
  created() {
    this.id = this.$route.query.id
    this.version = this.$route.query.version ? this.$route.query.version : ''
    this.year = this.$route.query.year ? this.$route.query.year : ''
    this.month = this.$route.query.month ? this.$route.query.month : ''
    if (this.version) {
      //历史修改版本
      getHistoryDetial({ id: this.id, version: this.version }).then((res) => {
        if (res.data.code == 0) {
          this.personDetail = res.data.data
        }
      })
    } else if (this.year && this.month) {
      //历史版本
      getJobDetial({ id: this.id, year: this.year, month: this.month }).then(
        (res) => {
          if (res.data.code == 0) {
            this.personDetail = res.data.data
          }
        }
      )
    } else {
      // 正常详情
      personnelGet(this.id).then((res) => {
        if (res.data.code == 0) {
          this.personDetail = res.data.data
        }
      })
    }
    this.getByType()
  },
  methods: {
    ...mapActions([
      'getposition',
      'getpositionLevel',
      'getpoliticalType',
      'getcontractType',
      'geteducation',
      'getregisteredNature',
      'getpositionStatus',
      'gethealthStatus'
    ]),
    //通过字典值过去字典名
    getByTypeName(value, list) {
      let byType = list.find((item) => {
        return item.valuename == value
      })
      if (byType) {
        return byType.keyname
      } else {
        return value
      }
    },
    //获取是否 是领导
    getIsLead() {
      //总经理、副总经理、总经理助理、党委书记、党委副书记、纪委书记、纪委副书记、工会主席
      //北京园福源物业管理有限公司党总支副书记、经理、团委书记（不是领导)；
      let IsLeadList = [
        '1300',
        '1305',
        '1310',
        '1315',
        '1320',
        '1325',
        '1330',
        '1335',
        '1340',
        '1345',
        '1350'
      ]
      let IsLead = IsLeadList.indexOf(this.personDetail.position)
      // console.log(IsLead); // IsLead为-1  不是领导
      return IsLead
    },
    // 获取当前页面所需字典表
    getByType() {
      //减员原因
      this.getpositionStatus()
      //行政职务
      this.getposition()
      //职级
      this.getpositionLevel()
      //政治面貌
      this.getpoliticalType()
      //劳动合同类型
      this.getcontractType()
      //学历
      this.geteducation()
      //户口性质
      this.getregisteredNature()
      //健康状况
      this.gethealthStatus()
    },
    setpop() {
      this.ispop = true
    },
    // 确定减员
    handleOk(e) {
      this.confirmLoading = true
      let params = this.delData
      params.id = this.id
      updatePositionStatus(params).then((res) => {
        if (res.data.code == 0) {
          this.$message.success('减员操作成功')
          this.ispop = false
          this.goBack()
          this.confirmLoading = false
        } else {
          this.confirmLoading = false
        }
      })
    },
    goBack() {
      this.$router.push('/roster')
    },
    // 下拉
    handleMenuClick(e) {
      let key = e.key.split('_')
      this.printKey = key[0]
      this.isPrint = {
        printTitle: key[1]
      }
      this.setisPrint()
    },
    setisPrint() {
      this.isPrint.printStatus = true
      if (this.printKey === '1') {
        //对内
        document.title =
          '人员信息表-' +
          this.personDetail.fullName +
          this.$printFormatDate(new Date())
      } else {
        document.title =
          '个人履历表-' +
          this.personDetail.fullName +
          this.$printFormatDate(new Date())
      }
    }
  }
}
</script>
<style scoped>
.print-border {
  height: auto;
  overflow: hidden;
  font-family: '宋体';
  margin: 0px 30px 20px 30px;
  background-color: #333333 !important;
}
/deep/ .ant-descriptions-view table {
  border-collapse: separate;
}
.Pprintd-cont-title {
  border: 2px solid #333333;
  border-bottom: 0;
  border-top: 0;
}
.Pprintd-cont-title:nth-child(1) {
  border: 2px solid #333333;
  border-bottom: 0;
}
/deep/ .ant-descriptions-view table tbody tr th,
/deep/ .ant-descriptions-view table tbody tr td {
  border: none !important;
  border: 0 !important;
  background: #fff;
}
/deep/ .ant-descriptions-view table tbody tr {
  border: none !important;
  border: 0 !important;
}
.print-poths .print-title,
.print-poths .isImg {
  background-color: #fff !important;
}
</style>
<style lang="scss" scoped>
.detial-top {
  background: #fff;
  padding: 0 50px 50px 50px;
  position: relative;
  .detial-top-btn {
    position: absolute;
    right: 90px;
    top: 0;
  }
}
.detial-cont {
  margin: 24px 16px;

  .detial-cont-title {
    background: #fff;
    height: 55px;
    color: rgba(0, 0, 0, 0.85);
    font-size: 16px;
    line-height: 55px;
    text-align: left;
    padding-left: 32px;
  }
  .detial-cont-view {
    background: #fff;
    padding: 30px;
    .personage {
      // height: 360px;
      border: #e9e9e9 solid 1px;
      border-radius: 4px;
      .personage-title {
        padding-left: 24px;
        height: 44px;
        color: rgba(0, 0, 0, 0.85);
        background-color: rgba(250, 250, 250, 1);
        border-bottom: #e9e9e9 solid 1px;
        border-radius: 4px;
        font-size: 14px;
        line-height: 44px;
      }
      .personage-cont {
        padding: 16px 24px 0 24px;
      }
    }
  }
}

.dep-form {
  width: 468px;
  margin-top: 40px;
  .dep-form-item {
    display: flex;
    align-items: center;
    justify-content: flex-start;
    .dep-form-lable {
      width: 70px;
      height: 21px;
      color: rgba(0, 0, 0, 0.85);
      font-size: 14px;
      line-height: 21px;
      text-align: left;
    }
  }
  .operating-checkbox-btn {
    display: flex;
    align-items: center;
    justify-content: center;
  }
}
.print-scrollY {
  overflow-y: scroll;
  max-height: calc(100vh - 400px);
}
// .print-scrollY::-webkit-scrollbar {
//   display: none;
// }
// 打印内容不能嵌套写样式
.print-title {
  text-align: center;
  font-size: 22px;
  font-weight: 700;
  height: 50px;
  line-height: 50px;
  font-family: '宋体';
}
.Pprintd-cont-title {
  text-align: center;
  background-color: rgb(191, 191, 191);
  height: 40px;
  line-height: 40px;
  font-weight: 700;
  font-size: 18px;
  // border-bottom: 3px solid #c3c3c3;
}
.printCenter {
  text-align: center;
  color: #000000;
}
.haveImg {
  width: 100%;
  display: flex;
  align-items: flex-start;
  justify-content: center;
  // border: 1px solid #c3c3c3;
}
.haveImg-left {
  width: 87%;
}
.isImg {
  height: 136px;
  width: 13%;
  display: flex;
  align-items: center;
  justify-content: center;
  border-top: 2px solid #333;
  border-right: 2px solid #333;
  z-index: 100;
}
.fwLabel {
  font-weight: 800;
}
</style>
<style lang="scss">



// WEBPACK FOOTER //
// src/views/PersonnelManagement/PersonnelDetails copy(备份).vue